import React, { FunctionComponent } from 'react';
import t from 'rcm-i18n';

interface Props {
    orderTotals: any;
}

const Totals: FunctionComponent<Props> = (props) => {
    const orderTotals = props.orderTotals;
    if (!orderTotals) {
        return null;
    }
    return (
        <tbody>
            <tr className="bvPv">
                <td>
                    {t('BV Total')}
                </td>
                <td className="money bvSubtotalVal">
                    {orderTotals.formatted.bvSubTotal}
                </td>
            </tr>
            <tr className="bvPv">
                <td>
                    {t('PV Total')}
                </td>
                <td className="money pvSubtotalVal">
                    {orderTotals.formatted.pvSubTotal}
                </td>
            </tr>
            <tr className="subtotal">
                <td>
                    {t('Subtotal')}
                </td>
                <td className="money subtotalVal">
                    {orderTotals.formatted.subTotal}
                </td>
            </tr>
            {orderTotals.discount != 0 && orderTotals.totalCalculated &&
                <tr className="discounts finalTotal">
                    <td>
                        {t('Discounts')}
                    </td>
                    <td className="money totalsDiscountTotal">
                        {orderTotals.formatted.discount}
                    </td>
                </tr>
            }
            {orderTotals.couponDiscount != 0 && orderTotals.totalCalculated &&
                <tr className="couponDiscount finalTotal">
                    <td>
                        {t('Coupon Discount')}
                    </td>
                    <td className="money totalsCouponDiscountTotal">
                        {orderTotals.formatted.couponDiscount}
                    </td>
                </tr>
            }
            {orderTotals.totalCalculated &&
                <tr className="tax finalTotal">
                    <td>
                        {t('Tax')}
                    </td>
                    <td className="money totalsTaxTotal">
                        {orderTotals.formatted.tax}
                    </td>
                </tr>
            }
            {orderTotals.totalCalculated &&
                <tr className="shipping finalTotal">
                    <td>
                        {t('Shipping')}
                    </td>
                    <td className="money totalsShipTotal">
                        {orderTotals.formatted.shipping}
                    </td>
                </tr>
            }
            {orderTotals.totalCalculated &&
                <tr className="total finalTotal">
                    <td>
                        {t('Total')}
                    </td>
                    <td className="money totalsFinalTotal">
                        {orderTotals.formatted.total}
                    </td>
                </tr>
            }
        </tbody>
    );
};

export default Totals;
